import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import classnames from 'classnames'
import { adminAddFaculty } from '../../../redux/action/adminAction'
import AdminHomeHelper from '../../../Components/AdminHomeHelper'


const AdminAddFaculty = () => {
    const store = useSelector((state) => state)
    const dispatch = useDispatch()
    const history = useHistory()

    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [avatar, setAvatar] = useState('')


    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])


    useEffect(() => {
        if (store.admin.adminAddFacultyFlag) {
            setError({})
        }
    }, [store.admin.adminAddFacultyFlag])

    useEffect(() => {
        if (store.error || store.admin.adminAddFacultyFlag) {
            setIsLoading(false)
        }
        else {
            setIsLoading(true)
        }
    }, [store.error, store.admin.adminAddFacultyFlag])


    const [formData, setFormData] = useState({
        date: '2023-05-17',
        course: '',
        period: [],
        attendanceType: 'Class Hour',
        faculty: '',
        subject: '',
        unit: '',
        portionCovered: '',
        planDeviationRemarks: ''
    });


    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Validate form (for simplicity, not implemented here)
        setTimeout(() => {
            setIsLoading(false);
            console.log(formData);
        }, 1000);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            setFormData({
                ...formData,
                period: [...formData.period, value]
            });
        } else {
            setFormData({
                ...formData,
                period: formData.period.filter((period) => period !== value)
            });
        }
    };

    return (

        <div>
            {store.admin.isAuthenticated ? (<>
                <div className="container-fluid">
                    <div className="row ">
                        <div className="col-3 p-0">
                            <AdminHomeHelper />
                        </div>
                        <div className="col-9 ">
                            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h5><Link to='/admin/allFaculties' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" />Add Faculty TimeTable</h3>
                                <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <form noValidate onSubmit={formHandler}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="dateId">Date</label>
                                            <input
                                                type="date"
                                                name="date"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.date,
                                                })}
                                                id="dateId"
                                                value={formData.date}
                                                onChange={handleInputChange}
                                            />
                                            {error.date && <div className="invalid-feedback">{error.date}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="courseId">Course</label>
                                            <select
                                                name="course"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.course,
                                                })}
                                                id="courseId"
                                                value={formData.course}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="course1">Course 1</option>
                                                <option value="course2">Course 2</option>
                                            </select>
                                            {error.course && <div className="invalid-feedback">{error.course}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Period</label><br />
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((period) => (
                                                <label key={period} className="mr-3">
                                                    <input
                                                        type="checkbox"
                                                        value={period}
                                                        checked={formData.period.includes(String(period))}
                                                        onChange={handleCheckboxChange}
                                                    /> {period}
                                                </label>
                                            ))}
                                        </div>

                                        <div className="form-group">
                                            <label>Attendance Type</label><br />
                                            {["Class Hour", "Exam Hour", "Other Hour"].map((type) => (
                                                <label key={type} className="mr-3">
                                                    <input
                                                        type="radio"
                                                        name="attendanceType"
                                                        value={type}
                                                        checked={formData.attendanceType === type}
                                                        onChange={handleInputChange}
                                                    /> {type}
                                                </label>
                                            ))}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="facultyId">Faculty</label>
                                            <input
                                                type="text"
                                                name="faculty"
                                                className="form-control"
                                                id="facultyId"
                                                value={formData.faculty}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="subjectId">Subject</label>
                                            <select
                                                name="subject"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.subject,
                                                })}
                                                id="subjectId"
                                                value={formData.subject}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="subject1">Subject 1</option>
                                                <option value="subject2">Subject 2</option>
                                            </select>
                                            {error.subject && <div className="invalid-feedback">{error.subject}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="unitId">Unit</label>
                                            <select
                                                name="unit"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.unit,
                                                })}
                                                id="unitId"
                                                value={formData.unit}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="unit1">Unit 1</option>
                                                <option value="unit2">Unit 2</option>
                                            </select>
                                            {error.unit && <div className="invalid-feedback">{error.unit}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="portionCoveredId">Portion Covered</label>
                                            <textarea
                                                name="portionCovered"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.portionCovered,
                                                })}
                                                id="portionCoveredId"
                                                value={formData.portionCovered}
                                                onChange={handleInputChange}
                                            />
                                            {error.portionCovered && <div className="invalid-feedback">{error.portionCovered}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="planDeviationRemarksId">Plan Deviation Remarks</label>
                                            <textarea
                                                name="planDeviationRemarks"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.planDeviationRemarks,
                                                })}
                                                id="planDeviationRemarksId"
                                                value={formData.planDeviationRemarks}
                                                onChange={handleInputChange}
                                            />
                                            {error.planDeviationRemarks && <div className="invalid-feedback">{error.planDeviationRemarks}</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row justify-content-center">
                                    <div className="col-md-1">
                                        {isLoading && (
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {!isLoading && <button type="submit" className="btn btn-info">Search</button>}
                            </form>
                        </div>
                    </div>
                </div></>) : (history.push('/'))}

        </div>



    )
}

export default AdminAddFaculty
